import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { InvoiceHandlingMode } from '../../../../../features/invoice-theme/theme.types';

@Component({
  selector: 'app-invoice-preview',
  templateUrl: './invoice-preview.component.html',
  styleUrl: './invoice-preview.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoicePreviewComponent {
  mode = input.required<InvoiceHandlingMode>();
}
